import * as React from 'react';
import { Component } from 'react';
import { Field, Form, reduxForm } from 'redux-form';
import { enableAutosave } from '../../redux/actions/general/autosave';
import styles from '../../styles/forms/my_company_members/FinancialForm.scss';
import { withRouter } from 'react-router';
import { subscribe } from 'react-contextual/dist/react-contextual.es';
import Localization from '../../helpers/Localization';
import { __, mapStateToProps, setTableParams } from '../../core/utils';
import { map } from 'lodash';
import classNames from 'classnames';
import Input from '../../components/Input';
import Select from '../../components/Select';
import EditIcon from '../../assets/images/edit-16x16.svg';
import Tooltip from '../../components/Tooltip';
import {
  readCompanyMemberFinancialPaycheckData,
  readCompanyMemberFinancialRateData,
} from '../../redux/actions/table/my_company_members';
import { dateFrom } from '../../core/utils';

@reduxForm({
  form: 'my_company_members.financial',
  enableReinitialize: true,
})
@withRouter
@mapStateToProps((state) => ({
  table: state.table['my_company_members'],
  user_id: state.auth.id,
}))
@subscribe(Localization, 'localization')
class FinancialForm extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  UNSAFE_componentWillReceiveProps() {
    enableAutosave(this.props.form);
  }

  render() {
    const { localization, user_id, data, initialValues } = this.props;

    const disabled = false;

    const {
      paycheck_changed_fields,
      rate_changed_fields,
      compensation_future,
      rate_future,
    } = initialValues;

    const currency_options = map(localization.currencies, (currency) => {
      return {
        value: currency.id,
        label: [currency.code, currency.name].join(' - '),
      };
    });

    const isChangedPaycheckField = (fieldName) => {
      return paycheck_changed_fields?.[fieldName] === true;
    };

    const isChangedRateField = (fieldName) => {
      return rate_changed_fields?.[fieldName] === true;
    };

    const getCompensationFutureTooltip = (fieldName) => {
      // if (compensation_future && compensation_future[fieldName] != null) {
      //   return `NEXT CHANGE: ${dateFrom(
      //     compensation_future?.paycheck_start_date,
      //     true
      //   )}\nNEW VALUE: ${compensation_future[fieldName]}`;
      // }
      // return null;
      if (compensation_future && compensation_future[fieldName] != null) {
        const formattedDate = dateFrom(
          compensation_future?.paycheck_start_date,
          true
        );

        if (fieldName === 'paycheck_currency_id') {
          return `NEXT CHANGE: ${formattedDate}\nNEW VALUE: ${
            compensation_future?.paycheck_currency_code || ''
          }`;
        }

        return `NEXT CHANGE: ${formattedDate}\nNEW VALUE: ${
          compensation_future[fieldName]
        } ${compensation_future?.paycheck_currency_code || ''}`;
      }
      return null;
    };

    const getRateFutureTooltip = (fieldName) => {
      if (rate_future && rate_future[fieldName] != null) {
        const formattedDate = dateFrom(rate_future?.rate_start_date, true);

        if (fieldName === 'rate_currency_id') {
          return `NEXT CHANGE: ${formattedDate}\nNEW VALUE: ${
            rate_future?.rate_currency_code || ''
          }`;
        }

        return `NEXT CHANGE: ${formattedDate}\nNEW VALUE: ${
          rate_future[fieldName]
        } ${rate_future?.rate_currency_code || ''}`;
      }
      return null;
    };

    return (
      <Form onSubmit={this.props.handleSubmit}>
        <div className={styles.form}>
          <div className={classNames(styles.flex, styles.groupTitleRow)}>
            <div className={styles.f1}>
              <label className={styles.label}>
                {__('my-company-members.flyout.paycheck-title')}
              </label>
            </div>
            <div className={classNames(styles.edit, styles.groupTitleEdit)}>
              <Tooltip
                text={__('my-company-members.flyout.edit-paycheck-group')}
              >
                <EditIcon
                  onClick={(e) => {
                    e.stopPropagation();

                    readCompanyMemberFinancialPaycheckData(
                      this.props.initialValues.user_id
                    ).then(({ response }) => {
                      setTableParams('my_company_members', {
                        edit_my_company_member_financial_paycheck_group_wizard: true,
                        financialPaycheckData: response,
                      });
                    });
                  }}
                />
              </Tooltip>
            </div>
          </div>
          <div className={styles.flex}>
            <div className={styles.f1}>
              <Field
                options={currency_options}
                //disabled={this.isChanged('paycheck_currency_id')}
                disabled={true}
                name='paycheck_currency_id'
                component={Select}
                orangeArrow={isChangedPaycheckField('paycheck_currency_id')}
                // orangeArrowTooltip={`NEXT CHANGE: ${data?.next_change}\nNEW VALUE: ${data?.new_value}`}
                orangeArrowTooltip={getCompensationFutureTooltip(
                  'paycheck_currency_id'
                )}
                label={__('my_company_members.flyout.paycheck_currency')}
                searchable
              />
            </div>
            <div className={styles.f1}></div>
            <div className={styles.f1}></div>
          </div>
          <div className={styles.flex}>
            <div className={styles.f1}>
              <Field
                // disabled={this.isChanged('brutto_2')}
                disabled={true}
                name='brutto_2'
                component={Input}
                orangeArrow={isChangedPaycheckField('brutto_2')}
                orangeArrowTooltip={getCompensationFutureTooltip('brutto_2')}
                label={__('my_company_members.flyout.brutto_2')}
              />
            </div>
            <div className={styles.f1}>
              <Field
                // disabled={this.isChanged('brutto_1')}
                disabled={true}
                name='brutto_1'
                component={Input}
                orangeArrow={isChangedPaycheckField('brutto_1')}
                orangeArrowTooltip={getCompensationFutureTooltip('brutto_1')}
                label={__('my_company_members.flyout.brutto_1')}
              />
            </div>
            <div className={styles.f1}>
              <Field
                // disabled={this.isChanged('netto')}
                disabled={true}
                name='netto'
                component={Input}
                orangeArrow={isChangedPaycheckField('netto')}
                orangeArrowTooltip={getCompensationFutureTooltip('netto')}
                label={__('my_company_members.flyout.netto')}
              />
            </div>
          </div>
          <div className={styles.dividerLine} />
          <div className={classNames(styles.flex, styles.groupTitleRow)}>
            <div className={styles.f1}>
              <label className={styles.label}>
                {__('my-company-members.flyout.chargeout-title')}
              </label>
            </div>
            <div className={classNames(styles.edit, styles.groupTitleEdit)}>
              <Tooltip text={__('my-company-members.flyout.edit-rate-group')}>
                <EditIcon
                  onClick={(e) => {
                    e.stopPropagation();
                    readCompanyMemberFinancialRateData(
                      this.props.initialValues.user_id
                    ).then(({ response }) => {
                      setTableParams('my_company_members', {
                        edit_my_company_member_financial_rate_group_wizard: true,
                        financialRateData: response,
                      });
                    });
                  }}
                />
              </Tooltip>
            </div>
          </div>
          <div className={styles.flex}>
            <div className={styles.f1}>
              <Field
                options={currency_options}
                // disabled={this.isChanged('rate_currency_id')}
                disabled={true}
                name='rate_currency_id'
                component={Select}
                orangeArrow={isChangedRateField('rate_currency_id')}
                orangeArrowTooltip={getRateFutureTooltip('rate_currency_id')}
                label={__('my_company_members.flyout.rate_currency')}
                searchable
              />
            </div>
            <div className={styles.f1}></div>
            <div className={styles.f1}></div>
          </div>
          <div className={styles.flex}>
            <div className={styles.f1}>
              <Field
                // disabled={this.isChanged('hourly_rate')}
                disabled={true}
                name='hourly_rate'
                component={Input}
                orangeArrow={isChangedRateField('hourly_rate')}
                orangeArrowTooltip={getRateFutureTooltip('hourly_rate')}
                label={__('my_company_members.flyout.hourly_rate')}
              />
            </div>
            <div className={styles.f1}>
              <Field
                // disabled={this.isChanged('chargeout_rate')}
                disabled={true}
                name='chargeout_rate'
                component={Input}
                orangeArrow={isChangedRateField('chargeout_rate')}
                orangeArrowTooltip={getRateFutureTooltip('chargeout_rate')}
                label={__('my_company_members.flyout.chargeout_rate')}
              />
            </div>
            <div className={styles.f1}></div>
          </div>
        </div>
      </Form>
    );
  }
}

export default FinancialForm;
